import {
  SET_ATTENDANT_STATUS_FILTER_VALUE,
  CREATE_SUITES_STAFF_SUCCEEDED,
  GET_SUITES_STAFF_REQUESTED,
  GET_SUITES_STAFF_SUCCEEDED,
  GET_SUITES_STAFF_FAILED,
  REMOVE_SUITES_STAFF_SUCCEEDED,
  SEARCH_SUITES_STAFF_SUCCEEDED,
  UPDATE_SUITES_STAFF_SUCCEEDED,
  UPDATE_TOGGLE,
} from './constants'
import { get, keyBy, omit } from 'lodash'

export const defaultState = {
  attendantStatusFilterValue: null,
  searchSuitesStaffValue: null,
  toggle: {
    allMenusAccess: false,
    allStandsAccess: false
  }
}

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case CREATE_SUITES_STAFF_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId
        }
      }
    }

    case GET_SUITES_STAFF_REQUESTED: {
      return {
        ...state,
        isloading: true
      }
    }

    case GET_SUITES_STAFF_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        isloading: false,
        byId
      }
    }

    case GET_SUITES_STAFF_FAILED: {
      return {
        ...state,
        isloading: false
      }
    }

    case REMOVE_SUITES_STAFF_SUCCEEDED: {
      const editedState = omit(state.byId, payload)

      return {
        ...state,
        byId: editedState
      }
    }

    case UPDATE_SUITES_STAFF_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId
        }
      }
    }

    case UPDATE_TOGGLE:
      const key = get(payload, 'key')
      const value = get(payload, 'value')

      return {
        ...state,
        toggle: {
          ...state.toggle,
          [key]: value
        }
      }

    case SEARCH_SUITES_STAFF_SUCCEEDED:

    return {
      ...state,
      searchSuitesStaffValue: payload,
    }

    case SET_ATTENDANT_STATUS_FILTER_VALUE:

    return {
      ...state,
      attendantStatusFilterValue: payload,
    }

    default:
      return state
  }
}
